import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.25 1.25C1.03579 1.25 0 2.28579 0 3.5V20.5C0 21.7142 1.03579 22.75 2.25 22.75H21.75C22.9642 22.75 24 21.7142 24 20.5V3.5C24 2.8804 23.791 2.31301 23.3931 1.89526C22.9941 1.47626 22.4441 1.25 21.85 1.25H2.25ZM8.92786 10.0156C8.92786 9.60141 9.26364 9.26562 9.67786 9.26562H14.1779C14.5921 9.26562 14.9279 9.60141 14.9279 10.0156C14.9279 10.4298 14.5921 10.7656 14.1779 10.7656H9.67786C9.26364 10.7656 8.92786 10.4298 8.92786 10.0156ZM4.858 4.43948C4.53979 4.1743 4.06686 4.2173 3.80169 4.53551C3.53652 4.85371 3.57951 5.32664 3.89772 5.59181L6.20632 7.51564L3.89772 9.43948C3.57951 9.70465 3.53652 10.1776 3.80169 10.4958C4.06686 10.814 4.53979 10.857 4.858 10.5918L7.858 8.09181C8.02899 7.94931 8.12786 7.73823 8.12786 7.51564C8.12786 7.29306 8.02899 7.08197 7.858 6.93948L4.858 4.43948Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }